import { Component, OnInit, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldConfig } from '@career/pocket-forms/models/field';

@Component({
  selector: 'app-sky-login',
  templateUrl: './sky-login.component.html',
  styleUrls: ['./sky-login.component.scss']
})
export class SkyLoginComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
